import { TUserProfile } from '@/types/user-profile'
import Service, { getCallApiFunction } from '../service'

export type VipFollowersParamsType = {
  merchantId?: number
}

type ResponseType = {
  isSuccess: boolean
  memberInfo: TUserProfile[]
}

class FetchVipFollowersApi extends Service {
  constructor({ merchantId }: VipFollowersParamsType) {
    super()
    this.config = {
      url: '/v1/livemall/member/vip/merchant',
      method: 'GET',
      params: {
        merchantId,
      },
    }
  }
}

export const fetchVipFollowers = async (params: VipFollowersParamsType): Promise<ResponseType> => getCallApiFunction(new FetchVipFollowersApi(params))
